var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { cloneDeep, forIn } from 'lodash';
import { Entity } from '.'; // 组件唯一标识计数

var idCounter = 0;
/**
 * 实体类工厂方法
 *
 * 根据实体描述信息创建对应的实体类
 *
 * @param name - 实体名称
 * @param desc - 实体描述信息
 */

export function EntityFactory(name, desc) {
  var apiPath = desc.apiPath,
      apiRoot = desc.apiRoot,
      paramsFilter = desc.paramsFilter,
      propertiesDefination = desc.properties,
      filtersDefination = desc.filters;

  var NewEntity = function (_super) {
    __extends(NewEntity, _super);

    function NewEntity(params) {
      var _this = _super.call(this, params) || this; // 实体 ID


      _this.id = name + "-" + idCounter;
      idCounter++; // 存储路由参数
      // this.params = params;

      var properties = cloneDeep(propertiesDefination);
      var filters = cloneDeep(filtersDefination); // 处理属性候选项

      forIn(properties, function (property, name) {
        _this.initPropertyMeta(name, property, properties);
      }); // 获取筛选器候选项

      forIn(filters, function (filter, name) {
        var options = filter.options,
            source = filter.source;

        if (options && source && source.loadOnInit !== false) {
          _this.loadFilterOptions(name, source, params);
        }
      }); // 初始化实体的元信息定义

      _this.setMeta({
        properties: properties,
        filters: filters,
        apiPath: apiPath,
        apiRoot: apiRoot,
        paramsFilter: paramsFilter
      });

      return _this;
    }

    return NewEntity;
  }(Entity);

  return NewEntity;
}